import { Link } from 'react-router-dom';

/** Shared learner vocabulary. Routes reuse the existing workspaces and stored results. */
export function StudyLearningJourney({
  active,
  subjectKey = 'mathematics',
}: {
  active: 'practice' | 'assessment' | 'working';
  subjectKey?: string;
}) {
  const subject = encodeURIComponent(subjectKey);
  const items = [
    {
      key: 'practice',
      title: 'Practice',
      detail: 'Practise a skill. Reopen results and retry mistakes.',
      to: `/learn/study/subjects/${subject}?tab=practice`,
    },
    {
      key: 'assessment',
      title: 'Assessment',
      detail: 'Create a whole quiz from your materials. Submit answers and see explanations.',
      to: `/learn/study/subjects/${subject}?tab=assessments`,
    },
    {
      key: 'working',
      title: 'My working',
      detail:
        'Keep calculations and reasoning. These pages are not graded or submitted as quiz answers.',
      to: '/learn/study/working',
    },
  ];
  return (
    <nav
      aria-label="Practice, Assessment and My working"
      className="mt-5 grid gap-3 rounded-2xl border border-hairline bg-surface p-3 sm:grid-cols-3"
    >
      {items.map((item) => (
        <Link
          key={item.key}
          to={item.to}
          aria-current={active === item.key ? 'page' : undefined}
          className={`min-h-11 rounded-xl border p-3 text-sm ${active === item.key ? 'border-brand-sky bg-wash-sky' : 'border-hairline bg-canvas-pure hover:bg-wash-sky'}`}
        >
          <span className="font-extrabold">{item.title}</span>
          <span className="mt-1 block text-xs leading-relaxed text-slate2">{item.detail}</span>
        </Link>
      ))}
    </nav>
  );
}
